// extracted by mini-css-extract-plugin
export default {"root":"nW8uZl","title":"N069tx","info":"vrLbRo","mobile":"IM933Y","icon-button":"h7xevK","iconButton":"h7xevK","icon":"Tgp3fz"};